<div class="login-page">
  <div class="login-panel">
    <div style="text-align: center; margin-bottom: 2rem;">
      <a routerLink="/landing-page" style="cursor: pointer;">
        <img src="assets/images/logo/current_logo_transparent_white_letters.png" alt="FFL XCEL Logo" style="max-width: 250px; height: auto;" />
      </a>
    </div>

    <form [formGroup]="login_form" (ngSubmit)="loginClick()">
      <h1 class="login-title">Sign In</h1>

      <div class="modern-form-group">
        <label for="login-email">Email</label>
        <input id="login-email" class="form-control" [class.is-invalid]="login_form.get('login_email').touched && login_form.get('login_email').invalid" type="email" placeholder="Enter Email" formControlName="login_email" required />
        @if (login_form.get('login_email').touched && login_form.get('login_email').invalid) {
          <div class="text-danger small mt-1">Please enter a valid email address.</div>
        }
      </div>

      <div class="modern-form-group">
        <label for="login-psw">Password</label>
        <div class="input-group">
          <input id="login-psw" class="form-control" [type]="showPassword ? 'text' : 'password'" placeholder="Enter Password" formControlName="login_pwd" required />
          <button type="button" class="password-toggle" (click)="togglePassword()">
            <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>
        </div>
      </div>

      <div class="modern-form-group remember-me-container">
        <label class="remember-me">
          <input type="checkbox" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}">
          <span class="checkmark"></span>
          Remember Me
        </label>
      </div>
      <div style="margin-top: 1.5rem;">
        <button class="modern-btn" type="submit" [disabled]="login_form.invalid || isLoggingIn">
          @if (isLoggingIn) {
            <i class="fas fa-spinner fa-spin me-2"></i>
          }
          {{ isLoggingIn ? 'Signing in...' : 'Sign In' }}
        </button>
      </div>
    </form>

    <div class="footer-links">
      <span class="footer-link" (click)="forgotPasswordClick()">I forgot my password</span>
      <span class="footer-link" (click)="helpWithLoginClick()">Having issues logging in?</span>
    </div>
  </div>
</div>